import { Action } from "redux";
import { createAction, ActionsUnion, ActionWithPayload } from "../utils/utils";

export enum IoConfigActionEnum {
  SET_SELECTED_STANDARD_BOARD_ID = "Set current selected standard board",
  SET_SELECTED_IO_BOARD_ID = "Set current io standard board",
  SET_SELECTED_IO_CONFIGURATION_ID = "Set current selected io configuration",
  SET_SELECTED_STANDARD_NODE_ID = "Set current selected standard node",
  SET_SELECTED_IO_NODE_ID = "Set current selected io node",
  SET_SELECTED_STANDARD_POINT_ID = "Set current selected standard point",
  SET_SELECTED_IO_POINT_ID = "Set current selected io point",
  SET_SELECTED_STANDARD_ACTION_ID = "Set current selected standard action",
  SET_SELECTED_IO_ACTION_ID = "Set current selected io action",
  SET_STANDARD_BOARDS = "Set standard boards",
  SET_LOCAL_FETCHING_STATUS = "Set local fetch status",
  UPDATE_OPENED_BOARD_TYPES = "Update opened board types list",
  UPDATE_OPENED_STANDARD_BOARDS = "Update opened revisions list",
  UPDATE_STANDARD_POINTS = "Update standard points array",
  UPDATE_IO_NODE_POINTS = "Update io points array",
  SET_STANDARD_POINTS = "Set standard points",
  SET_IO_NODE_POINTS = "Set io points",
  SET_IO_CONFIGURATIONS = "Set io confgis",
  SET_IO_BOARDS = " Update io boards",
  SET_IO_BOARDS_GROUPED = " Update io boards grouped",
  UPDATE_OPENED_IO_BOARD_TYPES = "Update opened io board types",
  UPDATE_OPENED_IO_BOARDS = "Update opened io boards",
  UPDATE_OPENED_IO_REVISIONS = "Update opened io Revisions",
  SET_OPENED_ROWS = "Set whole object of opened rows",
  CLEAR_SELECTED_IO_IDS = "Clear selected io ids",
  UPDATE_IO_CONFIG_FILE_TEXT = "Update IO config file text"
}

export const ioConfigActions = {
  setLocalFetchingStatus: (
    status: State.FetchingStatus
  ): ActionWithPayload<IoConfigActionEnum.SET_LOCAL_FETCHING_STATUS, State.FetchingStatus> =>
    createAction(IoConfigActionEnum.SET_LOCAL_FETCHING_STATUS, status),

  //Selections in IO config
  setSelectedIoConfigurationId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_IO_CONFIGURATION_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_IO_CONFIGURATION_ID, id),
  setSelectedIoBoardId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_IO_BOARD_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_IO_BOARD_ID, id),
  setSelectedIoNodeId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_IO_NODE_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_IO_NODE_ID, id),
  setSelectedIoPointId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_IO_POINT_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_IO_POINT_ID, id),
  setSelectedIoActionId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_IO_ACTION_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_IO_ACTION_ID, id),
  clearSelectedIoIds: (): Action<IoConfigActionEnum.CLEAR_SELECTED_IO_IDS> =>
    createAction(IoConfigActionEnum.CLEAR_SELECTED_IO_IDS),
  updateOpenedIoBoardTypes: (
    boardTypeId: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_OPENED_IO_BOARD_TYPES, string> =>
    createAction(IoConfigActionEnum.UPDATE_OPENED_IO_BOARD_TYPES, boardTypeId),
  updateOpenedIoBoards: (
    boardTypeId: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_OPENED_IO_BOARDS, string> =>
    createAction(IoConfigActionEnum.UPDATE_OPENED_IO_BOARDS, boardTypeId),
  updateOpenedIoRevisions: (
    revisionId: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_OPENED_IO_REVISIONS, string> =>
    createAction(IoConfigActionEnum.UPDATE_OPENED_IO_REVISIONS, revisionId),
  setOpenedRows: (
    openedRows: State.OpenedRows
  ): ActionWithPayload<IoConfigActionEnum.SET_OPENED_ROWS, State.OpenedRows> =>
    createAction(IoConfigActionEnum.SET_OPENED_ROWS, openedRows),

  //Selections in standard boards
  setSelectedStandardBoardId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_STANDARD_BOARD_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_STANDARD_BOARD_ID, id),
  setSelectedStandardNodeId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_STANDARD_NODE_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_STANDARD_NODE_ID, id),
  setSelectedStandardPointId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_STANDARD_POINT_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_STANDARD_POINT_ID, id),
  setSelectedStandardActionId: (
    id: string
  ): ActionWithPayload<IoConfigActionEnum.SET_SELECTED_STANDARD_ACTION_ID, string> =>
    createAction(IoConfigActionEnum.SET_SELECTED_STANDARD_ACTION_ID, id),
  updateOpenedBoardTypes: (
    boardTypeId: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_OPENED_BOARD_TYPES, string> =>
    createAction(IoConfigActionEnum.UPDATE_OPENED_BOARD_TYPES, boardTypeId),
  updateOpenedStandardBoards: (
    revisionId: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_OPENED_STANDARD_BOARDS, string> =>
    createAction(IoConfigActionEnum.UPDATE_OPENED_STANDARD_BOARDS, revisionId),

  // Standard boards data handling
  setStandardBoards: (
    boards: Api.StandardBoard[]
  ): ActionWithPayload<IoConfigActionEnum.SET_STANDARD_BOARDS, Api.StandardBoard[]> =>
    createAction(IoConfigActionEnum.SET_STANDARD_BOARDS, boards),
  setStandardPoints: (
    points: Api.StandardPoint[]
  ): ActionWithPayload<IoConfigActionEnum.SET_STANDARD_POINTS, Api.StandardPoint[]> =>
    createAction(IoConfigActionEnum.SET_STANDARD_POINTS, points),
  updateStandardPoints: (
    board: Api.StandardBoard
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_STANDARD_POINTS, Api.StandardBoard> =>
    createAction(IoConfigActionEnum.UPDATE_STANDARD_POINTS, board),

  // IO configurations data handling
  setIoConfigurations: (
    ioConfigs: Api.IoConfiguration[]
  ): ActionWithPayload<IoConfigActionEnum.SET_IO_CONFIGURATIONS, Api.IoConfiguration[]> =>
    createAction(IoConfigActionEnum.SET_IO_CONFIGURATIONS, ioConfigs),
  setIoBoards: (
    ioBoards: Api.IoBoard[]
  ): ActionWithPayload<IoConfigActionEnum.SET_IO_BOARDS, Api.IoBoard[]> =>
    createAction(IoConfigActionEnum.SET_IO_BOARDS, ioBoards),
  setIoBoardsGrouped: (
    ioBoardsGrouped: Api.IoBoardsGroupedItem[]
  ): ActionWithPayload<IoConfigActionEnum.SET_IO_BOARDS_GROUPED, Api.IoBoardsGroupedItem[]> =>
    createAction(IoConfigActionEnum.SET_IO_BOARDS_GROUPED, ioBoardsGrouped),
  updateIoNodePoints: (
    ionodePoints: Api.IoNodePoint[]
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_IO_NODE_POINTS, Api.IoNodePoint[]> =>
    createAction(IoConfigActionEnum.UPDATE_IO_NODE_POINTS, ionodePoints),
  setIonodePoints: (
    points: Api.IoNodePoint[]
  ): ActionWithPayload<IoConfigActionEnum.SET_IO_NODE_POINTS, Api.IoNodePoint[]> =>
    createAction(IoConfigActionEnum.SET_IO_NODE_POINTS, points),

  // IO configurations file text
  updateIoConfigFileText: (
    ioConfigFileText: string
  ): ActionWithPayload<IoConfigActionEnum.UPDATE_IO_CONFIG_FILE_TEXT, string> =>
    createAction(IoConfigActionEnum.UPDATE_IO_CONFIG_FILE_TEXT, ioConfigFileText)
};

export type IoConfigActions = ActionsUnion<typeof ioConfigActions>;
